import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface TariffListActionsHeaderProps
  extends HeaderContext<TariffModel, unknown> {}

export const TariffListActionsHeader =
  (): // props: TariffListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
